export default "__VITE_ASSET__TqaYmTJN__"